import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-namecard-fill 25",
  "use": "icon-namecard-fill 25-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-namecard-fill 25\"><path d=\"M810.666667 234.666667a64 64 0 0 1 64 64v426.666666a64 64 0 0 1-64 64H213.333333a64 64 0 0 1-64-64V298.666667a64 64 0 0 1 64-64h597.333334z m-42.666667 362.666666H256v64h512v-64zM469.333333 341.333333H256v192h213.333333v-192z m298.666667 128H512v64h256v-64z m-362.666667-64v64h-85.333333v-64h85.333333z\" p-id=\"7823\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol